<template>
  <span>
    <!-- Tab -->
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Rfq</label>
          <div class="col-sm-9">
            <my-select
              disableFormControl="true"
              :selection.sync="form.rfq_id"
              :suggestions="rfqs"
              placeholder="Select Rfq"
            ></my-select>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-form-label">Quotaton Date</label>
          <div class="col-sm-8">
            <my-datepicker
              :date.sync="form.quotation_date"
              placeholder="Enter Quotaton Date"
            ></my-datepicker>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Quotation Number</label>
          <div class="col-sm-9">
            <input
              type="text"
              v-model="form.quotation_no"
              class="form-control"
              autocomplete="off"
              placeholder="Quotation Number"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Supplier</label>
          <div class="col-sm-9">
            <my-select
              disableFormControl="true"
              :selection.sync="form.supplier_id"
              :suggestions="suppliers"
              placeholder="Select Supplier"
            ></my-select>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "QuotationFormWidget",
  props: ["form"],
  data() {
    return {
      rfqs: [],
      suppliers: [
        {
          id: 1,
          name: "Supplier 1",
        },
        {
          id: 2,
          name: "Supplier 2",
        },
      ],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("quotations/masters");
      masters = masters.data;
      masters.rfqs.forEach((rfq) => {
        this.rfqs.push({
          id: rfq.id,
          name: rfq.rfq_no,
        });
      });
    },
  },
};
</script>
